import React, {useState} from 'react'
import '../css/destinos.css'
import { Outlet, Link } from "react-router-dom";
import pichilingue from '../assets/images/destinos/pichilingue.webp';
import mazatlan  from '../assets/images/destinos/mazatlan.png';
import mochis from '../assets/images/destinos/mochis.webp';
import Footer from '../components/Footer'
import reservacion from '../assets/images/cta/reservacion.svg'
import viajeGrupo from '../assets/images/cta/viajegrupo.svg'
import reserva from '../assets/images/cta/reservacion.svg'
import Booking from '../components/form/Booking';
import { useTranslation } from 'react-i18next';


export default function Destinos() {
    const { t } = useTranslation('destinos');
    const [isHovered, setIsHovered] = useState(null);


  return (
    <>
    <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                    <h3>{t('destinos')} </h3>
                    <p>{t('destinos_p')} </p>
                </div>                
            </div>
        </div>
    </section>
    <section className='destinos-content'>
        <Booking />
        <section className='d-none d-sm-none d-md-block'>
            <div className='container'>
                <div className='destinos_content_general'>
                    <div className='box_content_destinos'>
                    <Link to="/destino-la-paz">
                        <div className='box_group_card_destino' style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${pichilingue})` }} onMouseEnter={() => setIsHovered(1)} onMouseLeave={() => setIsHovered(null)}>
                            <div className='boxes_content_destino'>
                                <div className='box_content_title_destino'>
                                    <h2>La Paz, Baja California Sur.</h2>
                                </div>
                                <div className='box_content_subtext_destino'>                                    
                                    {isHovered === 1 && <p>{t('text1')} </p>}
                                </div>                            
                            </div>
                        </div>
                        </Link>
                    </div>
                                
                        <div className='box_content_destinos'> 
                        <Link to="/destino-mazatlan">
                            <div className='box_group_card_destino ' style={{  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${mazatlan})` }} onMouseEnter={() => setIsHovered(2)}
        onMouseLeave={() => setIsHovered(null)}>
                                <div className='boxes_content_destino'>
                                    <div className='box_content_title_destino'>
                                        <h2>Mazatlán, Sinaloa.</h2>
                                    </div>
                                    <div className='box_content_subtext_destino'>
                                        {isHovered === 2 && <p> {t('text2')} </p>}
                                    </div>
                                
                                </div>
                            </div>
                            </Link>
                        </div>                
                        <div className='box_content_destinos'>  
                        <Link to="/destino-los-mochis">
                            <div className='box_group_card_destino' style={{  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${mochis})` }}  onMouseEnter={() => setIsHovered(3)}
        onMouseLeave={() => setIsHovered(null)}>
                                <div className='boxes_content_destino'>
                                    <div className='box_content_title_destino'>
                                        <h2> Los Mochis, Sinaloa.</h2>
                                    </div>
                                    <div className='box_content_subtext_destino'>
                                    {isHovered === 3 && <p>  {t('text3')} </p>}
                                    </div>                               
                                </div>
                            </div>
                        </Link>
                        </div>
                    
                </div>
            </div>
        </section>

        <section className='d-block d-sm-block d-md-none'>
        <div className='container'>
                <div className='destinos_content_general'>                                      

                    <div className='box_content_destinos'>
                        <Link to="/destino-la-paz">
                            <div className='box_group_card_destino' style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${pichilingue})` }} onMouseEnter={() => setIsHovered(1)} onMouseLeave={() => setIsHovered(null)}>
                                <div className='boxes_content_destino'>
                                    <div className='box_content_title_destino'>
                                        <h2>La Paz, Baja California Sur.</h2>
                                    </div>
                                    <div className='box_content_subtext_destino'>                                    
                                        <p>{t('text1')} </p>
                                    </div>                            
                                </div>
                            </div>
                        </Link>
                    </div>                               
                          
                    <div className='box_content_destinos'> 
                        <Link to="/destino-mazatlan">
                            <div className='box_group_card_destino ' style={{  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${mazatlan})` }} onMouseEnter={() => setIsHovered(2)}
                                onMouseLeave={() => setIsHovered(null)}>
                                <div className='boxes_content_destino'>
                                    <div className='box_content_title_destino'>
                                        <h2>Mazatlán, Sinaloa.</h2>
                                    </div>
                                    <div className='box_content_subtext_destino'>
                                      <p> {t('text2')} </p>
                                    </div>
                                
                                </div>
                            </div>
                        </Link>
                    </div>              
                    <div className='box_content_destinos'>  
                        <Link to="/destino-los-mochis">
                            <div className='box_group_card_destino' style={{  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${mochis})` }}  onMouseEnter={() => setIsHovered(3)}
                                onMouseLeave={() => setIsHovered(null)}>
                                <div className='boxes_content_destino'>
                                    <div className='box_content_title_destino'>
                                        <h2> Los Mochis, Sinaloa.</h2>
                                    </div>
                                    <div className='box_content_subtext_destino'>
                                    <p>{t('text3')} </p>
                                    </div>                               
                                </div>
                            </div>
                        </Link>
                    </div>
                    
                </div>
            </div>
        </section>
    </section>

    <section className="callToAction">
        <div className='container'>
            <div>
                <h3> </h3>
            </div>
            <div className='callToAction_row'>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={reserva} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/rutas_horario">{t('cta_btn1')}</Link>     
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={viajeGrupo} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')}</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/viaje-en-grupo">{t('cta_btn2')}</Link>     
                        </div>
                    </div>
                </div>
                {/*<div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={whatsapp} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>Envianos un WhatsApp</h4>
                            </div>
                            <div>
                                <p>Comunícate con nosotros al instante. Ya sea que tengas preguntas sobre nuestro servicio, o sobre tu reservación nuestro equipo está listo para ayudarte.</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                        <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer">Enviar WhatsApp </a>                       
                        </div>
                    </div>
                </div>*/}
                 <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={reservacion} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                        <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn3')} </a>                        
                        </div>
                    </div>
                </div>
            </div>

        </div>
   </section>
    <Outlet />
    <Footer />
        
    
    
    </>
  )
}
